import { useEffect, useState } from "react";
import axios from "axios";
import { Quote } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BACKDROP =
  "https://customer-assets.emergentagent.com/job_bespoke-events-3/artifacts/7r9uugyf_image.png";

// Build a 2-letter monogram, e.g. "Damini & Parijat" -> "D & P"
const monogram = (name) => {
  const parts = name.split("&").map((p) => p.trim());
  if (parts.length >= 2) {
    return `${parts[0][0]} & ${parts[1][0]}`;
  }
  return name.slice(0, 2).toUpperCase();
};

const Testimonials = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/testimonials`)
      .then((res) => setItems(res.data.testimonials || []))
      .catch(() => setItems([]));
  }, []);

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-24 md:py-40 px-6 md:px-12 lg:px-24 overflow-hidden"
    >
      {/* Soft warm backdrop */}
      <div aria-hidden className="absolute inset-0 -z-10">
        <img
          src={BACKDROP}
          alt=""
          className="w-full h-full object-cover opacity-[0.05]"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#080B12] via-[#080B12]/95 to-[#080B12]" />
      </div>
      <div
        aria-hidden
        className="absolute -top-32 -left-32 w-[560px] h-[560px] rounded-full bg-[#6A1A25]/15 blur-[140px]"
      />
      <div
        aria-hidden
        className="absolute -bottom-40 -right-20 w-[480px] h-[480px] rounded-full bg-[#B8935C]/10 blur-[140px]"
      />

      <div className="relative max-w-7xl mx-auto">
        <div className="text-center mb-16 md:mb-20">
          <div className="overline mb-6 reveal">Couples Reviews</div>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight reveal">
            Words from
            <br />
            our <span className="italic text-[#B8935C]">couples</span>.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7">
          {items.map((t, i) => (
            <article
              key={t.name}
              data-testid={`couple-review-${i}`}
              className="reveal relative bg-[#121623]/60 border border-[#F0EBE1]/10 p-7 md:p-9 flex flex-col hover:border-[#B8935C]/40 transition-colors duration-700 group"
            >
              <Quote
                size={28}
                strokeWidth={1}
                className="text-[#B8935C]/40 mb-5"
              />
              <p className="text-[#F0EBE1]/75 text-[0.95rem] leading-relaxed font-light italic flex-1">
                {t.quote}
              </p>

              <div className="mt-7 pt-6 border-t border-[#F0EBE1]/10 flex items-center gap-4">
                {/* Monogram avatar */}
                <div className="flex-shrink-0 w-14 h-14 rounded-full border border-[#B8935C]/40 bg-gradient-to-br from-[#1A1F30] to-[#080B12] flex items-center justify-center">
                  <span className="font-serif italic text-[#B8935C] text-sm tracking-wider">
                    {monogram(t.name)}
                  </span>
                </div>
                <div>
                  <div
                    data-testid="testimonial-name"
                    className="font-serif text-lg text-[#F0EBE1] group-hover:text-[#B8935C] transition-colors"
                  >
                    {t.name}
                  </div>
                  <div className="overline text-[10px] mt-0.5">{t.event}</div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
